import { ErrorType } from "@/hooks/types";

const DisplayApproveErrors = ({ errors }: { errors: ErrorType[] }) => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <>
      <strong>The following errors occurred:</strong>
      {errors.map((error, index) => (
        <span className="block" key={`error-${index}`}>
          {error.validationErrors ? (
            error.validationErrors.map((validationError, i) => (
              <span className="block" key={`${validationError.field}-${i}`}>
                {validationError.message}
              </span>
            ))
          ) : (
            <span>{error.message}</span>
          )}
        </span>
      ))}
    </>
  );
};

export default DisplayApproveErrors;
